import React from 'react';

import { hot } from 'react-hot-loader/root';

import ChromeExtensionLandingHelmet from 'common/helmets/ChromeExtensionLandingHelmet';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';

import CannyLogoIcon from 'img/canny-icon.svg';
import ChromeLogo from 'img/chrome-logo.svg';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

const ChromeExtensionLanding = () => {
  return (
    <div className="integrationsLanding withoutImage">
      <ChromeExtensionLandingHelmet />
      <div className="integrationsLandingContainer">
        <div className="header">
          <div className="left">
            <div className="logosCombined">
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={CannyLogoIcon}
                alt="Canny Logo"
              />
              +
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={ChromeLogo}
                alt="Chrome Logo"
              />
            </div>
            <div className="text">
              <h1 className="title">Canny’s Chrome Extension</h1>
              <p className="subtitle">
                Capture feedback anywhere on the web with Canny’s Chrome Extension.
              </p>
              <div className="links">
                <a
                  className="LandingGlobal__cta"
                  href="https://chrome.google.com/webstore/detail/canny/ppljpoflocngelbkbmebgkpdbbjaejhi"
                  rel="noopener"
                  target="_blank">
                  Install extension
                </a>
                <a
                  href="https://help.canny.io/en/articles/5633815-chrome-extension"
                  rel="noopener"
                  target="_blank"
                  className="LandingIntegrations__install-link">
                  See install docs
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="features">
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Track feedback from anywhere</h2>
              <p className="subtitle">
                Just select the text you want and click on the Canny Extension. The post’s details
                will be filled in, and you just have to choose which board to add it&nbsp;to.
              </p>
            </div>
          </div>
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Associate feedback to actual users</h2>
              <p className="subtitle">
                The Chrome Extension can automatically detect users already in your Canny account.
                This links them to the feedback you’re collecting. You can also create new users in
                Canny directly from the extension.
              </p>
            </div>
          </div>
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Add votes to existing posts</h2>
              <p className="subtitle">
                See suggestions for existing posts so you don’t create duplicates. Then, add the
                user’s vote to the correct existing post.
              </p>
            </div>
          </div>
        </div>
        <LandingFooterCTA style="solid" />
      </div>
    </div>
  );
};

export default hot(ChromeExtensionLanding);
